import { useReducer, useMemo, useContext, useCallback } from "react";
import { ersReducer } from "./ers.reducer";
import { ersActionTypes as actions } from "./ers.actions";
import { ErsState } from "./ers.state";
import { fetchErs } from "src/api/ers";

const ERS_STATE = {
  error: null,
  data: {},
};

export const ErsStateProvider = ({ children }) => {
  const [state, dispatch] = useReducer(ersReducer, ERS_STATE);

  const value = useMemo(
    () => ({
      ...state,
      fetchData: async (slug) => {
        try {
          if (!Object.keys(state.data).includes(slug)) {
            const response = await fetchErs(slug);
            
            // Ensure the data is valid and convert to array if needed
            let validData = response.data;
            
            // If data is a string (likely HTML error response), use empty array
            if (typeof validData === 'string') {
              console.warn(`ERS API returned string data instead of array for slug: ${slug}. Using empty array as fallback.`);
              validData = [];
            }
            
            // If data is not an array, wrap it in an array or use empty array
            if (!Array.isArray(validData)) {
              console.warn(`ERS API returned non-array data for slug: ${slug}. Using empty array as fallback.`);
              validData = [];
            }
            
            dispatch({
              type: actions.ERS_DATA,
              payload: { slug, data: validData },
            });
          }
        } catch (error) {
          // On error, ensure we store an empty array for the slug to prevent future issues
          dispatch({
            type: actions.ERS_DATA,
            payload: { slug, data: [], error: error.message },
          });
        }
      },
    }),
    [state]
  );
  return <ErsState.Provider value={value}>{children}</ErsState.Provider>;
};
export const useErs = () => useContext(ErsState);
